import { Box } from "@mui/material"
import { Theme } from "@mui/material/styles"
import { MinusSquare, PlusSquare, XSquare } from "lucide-react"

// ----------------------------------------------------------------------

const ICON_SIZE = 20

export default function TreeView(theme: Theme) {
  return {
    MuiTreeView: {
      defaultProps: {
        defaultCollapseIcon: <MinusSquare size={ICON_SIZE} aria-label="Collapse" />,
        defaultExpandIcon: <PlusSquare size={ICON_SIZE} aria-label="Expand" />,
        defaultEndIcon: (
          <Box
            component="span"
            sx={{
              color: "text.secondary",
              display: "inline-flex",
              alignItems: "center"
            }}
          >
            <XSquare size={ICON_SIZE} aria-label="End node" />
          </Box>
        )
      }
    },
    MuiTreeItem: {
      styleOverrides: {
        label: { ...theme.typography.body2 },
        iconContainer: { width: "auto" }
      }
    }
  }
}
